/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Export_Error_ExportInputs */



/**
* | output |
* | --- |
* | "An error occurred during export" |
*
* @param {Intervention_Plan_Export_Error_ExportInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_export_error_export = /** @type {((inputs?: Intervention_Plan_Export_Error_ExportInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Export_Error_ExportInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("An error occurred during export")
	return /** @type {LocalizedString} */ ("Une erreur est survenue lors de l'exportation")
});